import React from "react";
import SecondaryHeading from "../../components/common/Typography/SecondaryHeading";
import Snippet from "../../components/common/SnippetIcon/Snippet";
import Paragraph from "../../components/common/Typography/Paragraph";
import Heading from "../../components/common/Typography/Heading";
import SpecialText from "../../components/common/Typography/SpecialText";
import MainButton from "../../components/common/MainButton/MainButton";
import AuxiliaryText from "../../components/common/Typography/AuxiliaryText";
import { PUBLIC_CONTENT_TO_CTA_CLASS } from "../Public/shared/publicLayoutSpec";

const PackageDetailsTable = () => {
  const data = [
    {
      content: "Profile and cover image",
      basic: true,
      pro: true,
    },
    {
      content: "ABN",
      basic: true,
      pro: true,
    },
    {
      content: "Licences and badges",
      basic: false,
      pro: true,
    },
    {
      content: "Social media links",
      basic: false,
      pro: true,
    },
    {
      content: "Business hours",
      basic: true,
      pro: true,
    },
    {
      content: "Featured services",
      basic: true,
      pro: true,
      snip: true,
      snippText: "Showcase additional skills to attract clients.",
    },
    {
      content: "Business payment methods",
      basic: true,
      pro: true,
      snip: true,
      snippText: "Show payment options you accept on your profile for easy transactions.",
    },
    {
      content: "Keywords",
      basic: "1",
      pro: "5",
    },
    {
      content: "Posts",
      basic: "2",
      pro: "10",
    },
    {
      content: "Featured posts",
      basic: false,
      pro: "10",
    },
    {
      content: "Images per post",
      basic: "1",
      pro: "5",
    },
    {
      content: "Portfolio gallery",
      basic: "8 images",
      pro: "20 images",
    },
    {
      content: "Priority search placement",
      basic: false,
      pro: true,
    },
    {
      content: "Profile reach",
      basic: "Standard",
      pro: "10× reach",
    },
    {
      content: "Traded membership links",
      basic: false,
      pro: true,
    },
    {
      content: "Business website link",
      basic: false,
      pro: true,
    },
    {
      content: "Google Business Profile link",
      basic: false,
      pro: true,
    },
    {
      content: "Business contact details",
      basic: false,
      pro: true,
      snip: true,
      snippText: "Direct contact via phone, mobile, and email.",
    },
    {
      content: "Core metrics and insights",
      basic: true,
      pro: true,
    },
    {
      content: "Advanced metrics and analytics",
      basic: false,
      pro: true,
    },
    {
      content: "Priority quote placement",
      basic: false,
      pro: true,
    },
    {
      content: "Messaging",
      basic: true,
      pro: true,
    }
  ];

  const renderFeatureValue = (value) => {
    if (value === true) {
      return <i className="fi fi-rs-check text-base"></i>;
    }
    if (value === false) {
      return <span className="text-gray-400">—</span>;
    }
    return <SpecialText variant={"TableBody"}>{value}</SpecialText>;
  };

  return (
    <div className="max-w-6xl mx-auto px-4">
      {/* Header Section */}
      <div className="text-center">
        <Heading variant={"h2"} className="font-bold">
          Choose the plan<br />that's right for you.
        </Heading>

        <SpecialText variant={"SectionDesc"}>
          No commitment. Cancel anytime.
        </SpecialText>
        
        {/* <SpecialText variant={"Caption"} className="text-gray-500">
          TradesPoster is available for businesses and tradies across Australia.
        </SpecialText> */}
      </div>

      {/* Comparison Table — 6rem below plan title */}
      <div className={`overflow-hidden ${PUBLIC_CONTENT_TO_CTA_CLASS}`}>
         {/* Header Row with Plan Names, Price and Try Free Buttons */}
         <div className="grid grid-cols-[2fr_1fr_1fr] py-6 px-8">
           {/* Empty space for feature column */}
           <div className="flex items-center justify-center">
           </div>
           
           {/* Basic Plan: Header, Price and Try Free Button */}
           <div className="flex flex-col items-center justify-center">
            <AuxiliaryText variant={"Eyebrow"}>Basic</AuxiliaryText>
            <div className="flex items-baseline">
              <SpecialText variant={"MetricMajor"}>
                $9.99
              </SpecialText>
              <SpecialText variant={"Date"}>/mo.</SpecialText>
            </div>
             <MainButton variant={"small"} className="mt-2">
               Trial
             </MainButton>
           </div>
           
           {/* Pro Plan: Header, Price and Try Free Button */}
          <div className="flex flex-col items-center justify-center">
               <AuxiliaryText variant={"Eyebrow"}>Pro</AuxiliaryText>
               <div className="flex items-baseline">
                 <SpecialText variant={"MetricMajor"}>
                   $19.99
                 </SpecialText>
                 <SpecialText variant={"Date"}>/mo.</SpecialText>
               </div>
             <MainButton variant={"small"} className="mt-2">
               Sign Up
             </MainButton>
           </div>
         </div>

         {data.map((feature, index) => (
                     <div 
             key={index}
             className="grid grid-cols-[2fr_1fr_1fr] py-2 px-8 border-b border-lightgray last:border-b-0"
           >
            {/* Feature Name */}
            <div className="flex items-center">
              <SpecialText 
                variant={"TableHeader"}
                className="pr-4"
              >
                {feature.content}
              </SpecialText>
              {feature.snip && (
                <div className="ml-2">
                  <Snippet variant={"icon"} text={feature.snippText} />
                </div>
              )}
            </div>
            
            {/* Basic Column */}
            <div className="flex items-center justify-center">
              {renderFeatureValue(feature.basic)}
            </div>
            
            {/* Pro Column */}
            <div className="flex items-center justify-center">
              {renderFeatureValue(feature.pro)}
            </div>
          </div>
        ))}
      </div>
      
      {/* Footer Note */}
      {/* <div className="text-center mt-8">
        <p className="text-sm text-gray-500">
          *Free trial available for new subscribers only
        </p>
      </div> */}
    </div>
  );
};

export default PackageDetailsTable;
